<div class="d-flex justify-content-between">
    <mat-card-subtitle>{{ title ? title : '' }}</mat-card-subtitle>
    <button *ngIf="showHelp" mat-stroked-button color="accent"><mat-icon>help_outline</mat-icon></button>
</div>

<div *ngIf="subtitle" class="card-header">{{ subtitle }}</div>
